import anime from 'animejs';

export function translateX(elements, aValue, aLoop = false, aDuration = 1000, aDelay = 0) {
  return anime({
    targets: elements,
    translateX: aValue,
    duration: aDuration,
    delay: aDelay,
    loop: aLoop,
    easing: 'spring',
  });
}

export function translateY(elements, aValue, aLoop = false, aDuration = 1000, aDelay = 0) {
  return anime({
    targets: elements,
    translateY: aValue,
    duration: aDuration,
    delay: aDelay,
    loop: aLoop,
    easing: 'spring',
  });
}

export function scrollDownIndicator(element, aValue) {
  return anime({
    targets: element,
    loop: true,
    direction: 'alternate',
    easing: 'linear',
    translateY: aValue,
  });
}
